import React from "react";
import CustomSvg from "../../svgs/CustomSvg";
import { Spinner } from "react-bootstrap";

export default function AmountPicker({
  btnTxt,
  btnFunc,
  subTxt,
  value,
  setValue,
  loading,
}) {
  const onIncrement = () => {
    const current = parseInt(value || "0", 10);
    if (current < 25000) setValue(String(current + 100));
  };

  const onDecrement = () => {
    const current = parseInt(value || "0", 10);
    if (current - 100 >= 100) setValue(String(current - 100));
  };

  const resetValue = (amount) => setValue(String(amount));

  const handleInputChange = (e) => {
    const val = e.target.value.replace(/,/g, ""); // remove commas

    if (val === "") {
      setValue("");
      return;
    }

    if (!/^\d+$/.test(val)) return;

    const inputValue = parseInt(val, 10);
    if (inputValue <= 5000000) {
      setValue(val); // store raw number string
    }
  };

  const formatWithCommas = (numStr) => {
    if (!numStr) return "";
    return parseInt(numStr, 10).toLocaleString("en-NG");
  };

  const submitValue = () => {
  const current = parseInt(value || "0", 10);
  if (current >= 100) {
    const amountInKobo = current * 100;
    btnFunc && btnFunc(amountInKobo);
  }
};


  return (
    <div className="w-full mx-auto">
      <div className="flex items-start justify-between mb-8">
        {/* Decrement Button */}
        <div
          onClick={onDecrement}
          className="cursor-pointer p-2 flex items-center justify-center bg-gray-700 rounded-md hover:bg-gray-600 transition flex-shrink-0"
          aria-label="Decrease amount"
          role="button"
          tabIndex={0}
        >
          <CustomSvg name="minus" />
        </div>

        {/* Input & presets */}
        <div className="flex flex-col  min-w-0">
          <input
            type="text"
            value={value === "" ? "" : formatWithCommas(value)}
            onChange={handleInputChange}
            min={100}
            max={25000}
            placeholder="Enter amount"
            className="mb-6 p-2 text-center text-white text-lg font-semibold bg-transparent border-b font-poppins placeholder-gray-400 min-w-0"
          />

          <div className="flex   mb-6 ml-10 space-x-4  ">
            {[5000, 15000, 25000].map((amount) => (
              <div
                key={amount}
                onClick={() => resetValue(amount)}
                className="bg-yellow-500 text-black cursor-pointer rounded-lg px-1 py-2 font-semibold font-poppins text-sm text-center hover:bg-yellow-500 transition "
              >
                {`N${amount.toLocaleString()}`}
              </div>
            ))}
          </div>

          <p className="text-white text-center font-poppins font-normal">
            {subTxt}
          </p>
        </div>

        {/* Increment Button */}
        <div
          onClick={onIncrement}
          className="cursor-pointer p-2 flex items-center justify-center bg-gray-700 rounded-md hover:bg-gray-600 transition flex-shrink-0"
          aria-label="Increase amount"
          role="button"
          tabIndex={0}
        >
          <CustomSvg name="plus" />
        </div>
      </div>

      {/* Submit Button */}
      <button
        onClick={submitValue}
        disabled={loading || parseInt(value || "0", 10) < 100}
        className={`w-full py-3 rounded-lg font-poppins font-semibold text-black bg-yellow-500 flex items-center justify-center gap-2 transition-opacity ${
          loading || parseInt(value || "0", 10) < 100
            ? "opacity-50 cursor-not-allowed"
            : "opacity-100"
        }`}
      >
        {loading ? (
          <Spinner size="sm" variant="light" />
        ) : (
          <>
            <p className="m-0">{btnTxt}</p>
            <CustomSvg name="arrow-right" color="#000" />
          </>
        )}
      </button>
    </div>
  );
}
